import { AuthorizationUrlStrategy } from '../strategies/authorization-url.strategy';
import { StandardAuthorizationUrlStrategy } from '../strategies/standard-authorization-url.strategy';
import { StandardTokenExchangeStrategy } from '../strategies/standard-token-exchange.strategy';
import { TokenExchangeStrategy } from '../strategies/token-exchange.strategy';
import { OAuth2Provider } from './base.provider';
import { BaseProfileFetcher } from '../profile/base-profile-fetcher';

export class GenericOAuth2Provider extends OAuth2Provider {
  constructor(
    config: any,
    authUrlStrategy?: AuthorizationUrlStrategy,
    tokenStrategy?: TokenExchangeStrategy,
    profileFetcher?: BaseProfileFetcher,
  ) {
    super(config, authUrlStrategy, tokenStrategy, profileFetcher);
  }

  protected createAuthorizationUrlStrategy(): AuthorizationUrlStrategy {
    return new StandardAuthorizationUrlStrategy();
  }

  protected createTokenExchangeStrategy(): TokenExchangeStrategy {
    return new StandardTokenExchangeStrategy();
  }
}
